import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export async function generatePdf(htmlContent: string): Promise<Blob> {
  const container = document.createElement("div");
  container.style.position = "fixed";
  container.style.top = "0";
  container.style.left = "0";
  container.style.zIndex = "-9999";
  container.innerHTML = htmlContent;
  document.body.appendChild(container);

  const canvas = await html2canvas(container, { scale: 1 }); // reduce size
  const imgData = canvas.toDataURL("image/jpeg", 0.8); // smaller size

  const pdf = new jsPDF("p", "mm", "a4");
  const imgWidth = 210;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;
  pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);

  document.body.removeChild(container);
  return pdf.output("blob");
}
